import $ from 'jquery';

/**
 * Retrieve the hash from the URL (if it exists), minus the number sign.
 * @param {String} url
 */
function parseHash(url) {
  if (!url.includes('#')) {
    return null;
  }
  return url.split('#').pop();
}

$('.js-tabs').each((index, tabs) => {
  const $tabs = $(tabs).find('.js-tab');
  const $tabButtons = $(tabs).find('.js-tab-button');

  const deactivateActive = () => {
    $tabs.filter('.is-active').removeClass('is-active');
    $tabButtons.filter('.is-active').removeClass('is-active');
    $tabButtons.filter('[aria-selected="true"]').attr('aria-selected', 'false');
  };

  const activate = (id) => {
    deactivateActive();
    $tabs.filter(`[id="${id}"]`).addClass('is-active');
    $tabButtons
      .filter(`[aria-controls="${id}"]`)
      .addClass('is-active')
      .attr('aria-selected', 'true');
    location.hash = `#${id}`;
  };

  $tabButtons.on('click', function (event) {
    const $tabButton = $(this);
    const id = $(this).attr('aria-controls');
    activate(id);
  });

  const hash = window.location.hash.substr(1);
  if ($tabs.filter(`[id="${hash}"]`).length >= 1) {
    activate(hash);
  }

  // Change tab on hash change (eg. back), if tab w/ match id exists.
  function handleHashchange(event) {
    let hash = parseHash(event.newURL);
    if ($tabs.filter(`[id="${hash}"]`).length >= 1) {
      activate(hash);
    }
  }
  window.addEventListener('hashchange', handleHashchange);
});
